<template>
  <div>
    <v-menu
      ref="timePicker"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="tempTime"
          :prepend-icon="icon"
          readonly
          v-on="on"
          :hideDetails="hideDetails"
          :label="label ? label : ''"
          :background-color="background ? background : ''"
          :clearable="clearable"
          :disabled="disabled"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu"
        v-model="tempTime"
        format="24hr"
        :disabled="disabled"
      >
        <v-spacer></v-spacer>
        <v-btn rounded depressed="" @click="menu = false, onInit()">取消</v-btn>
        <v-btn rounded depressed color="primary" @click="onUpdated()">設定</v-btn>
      </v-time-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tempTime: null,
      menu: false,
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  props: [ 'id', 'time', 'icon', 'label', 'background', 'hideDetails', 'clearable', 'disabled' ],
  created () {
    this.onInit()
  },
  watch: {
    time () {
      this.onInit()
    }
  },
  methods: {
    onUpdated () {
      this.$emit('updated', { id: this.id, time: this.tempTime })
      this.menu = false
    },
    onInit () {
      this.tempTime = this.time ? JSON.parse(JSON.stringify(this.time)) : null
    }
  }
}
</script>

<style>
</style>
